import { RELEASE_VERSION } from 'model';
import styles from './Version.module.css';

export const Version = () => (
	<div className={styles.container}>
		<div>
			<h3>Commit:</h3>
			<div className="commit">127a3efa88b1799c158ae8310776a4ba73508afb - refs/heads/main</div>
		</div>
		<div>
			<h3>Release Version:</h3>
			<div className="commit">{RELEASE_VERSION}</div>
		</div>

		<div>
			<h3>Run ID:</h3>
			<div className="runid">793</div>
		</div>
	</div>
);
